/**
 * Created by jv on 11/04/2017.
 */
const utils = require("Sources/utils/utils");

require("Styles/components/paginator.scss");

module.exports = class Paginator
{
  constructor(options)
  {
    /*
     * appendTo
     *
     * items
     * itemsPerPage
     * edges
     *
     * currentPage
     *
     * prevText
     * nextText
     *
     * onPageSwitch
     */

    if(utils.isNull(options) && utils.isObject(options))
    {
      throw "options must be defined";
    }

    this.appendTo = options.appendTo;

    this.items = options.items;
    this.itemsPerPage = options.itemsPerPage;
    this.edges = utils.isNumber(options.edges) ? options.edges : 2;
    this.pagesShown = utils.isNumber(options.pagesShown) ? options.pagesShown : 5;

    this.currentPage = utils.isNumber(options.currentPage) ? options.currentPage : 1;

    this.prevText = options.prevText;
    this.nextText = options.nextText;

    this.minPageCount = utils.isNumber(options.minPageCount) ? options.minPageCount : 2;

    this.onPageSwitch = options.onPageSwitch;

    this.paginatorEl = null;

    this.create();
  }

  create()
  {
    if(this._initialized !== true)
    {
      this.paginatorEl = $("<div class='paginator'></div>");

      this.rerender();

      this.paginatorEl.appendTo(this.appendTo);

      this._initialized = true;
    }
  }

  rerender()
  {
    if(utils.isNotNull(this.paginatorEl) && this.paginatorEl.length)
    {
      if(this.pageCount < this.minPageCount)
      {
        this.hide();
      }
      else
      {
        this.show();
      }

      var that = this;
      var addElipsis = false;

      this.paginatorEl.empty();

      if(this.currentPage < 1)
      {
        this.currentPage = 1;
      }
      else if(this.currentPage > this.pageCount)
      {
        this.currentPage = this.pageCount;
      }

      var prevBtn = $("<button class='btn btn-link prev-page-btn' type='button'>" + this.prevText + "</button>");
      prevBtn.on("click", function(e)
      {
        that.prevPage();
      });
      this.paginatorEl.append(prevBtn);

      if(this.currentPage === 1)
      {
        prevBtn.addClass("disabled");
      }

      for(var i = 0; i < this.pageCount; i++)
      {
        if((i < this.edges || i > (this.pageCount - 1 - this.edges)) || ((this.currentPage - 1 - (Math.floor(this.pagesShown / 2))) < i && i < (this.currentPage - 1 + (Math.floor(this.pagesShown / 2)))))
        {
          var switchPageBtn = $("<button class='btn btn-link switch-page-btn' type='button'>" + (i + 1) + "</button>").data("page-index", i + 1);

          if((i + 1) === this.currentPage)
          {
            switchPageBtn.addClass("active");
          }

          this.paginatorEl.append(switchPageBtn);
          addElipsis = true;
        }
        else if(addElipsis)
        {
          addElipsis = false;
          this.paginatorEl.append("<span class='switch-page-filler'>...</span>");
        }
      }

      this.paginatorEl.find(".switch-page-btn").on("click", function()
      {
        var pageIndex = $(this).data("page-index");
        that.goToPage(pageIndex);
      })

      var nextBtn = $("<button class='btn btn-link next-page-btn' type='button'>" + this.nextText + "</button>");
      nextBtn.on("click", function(e)
      {
        that.nextPage();
      });
      this.paginatorEl.append(nextBtn);

      if(this.currentPage === this.pageCount)
      {
        nextBtn.addClass("disabled");
      }
    }
  }

  updateItems(items)
  {
    this.items = items;
    this.rerender();
  }

  prevPage()
  {
    if(this.currentPage > 1)
    {
      this.goToPage(this.currentPage - 1);
    }
  }

  nextPage()
  {
    if(this.currentPage < this.pageCount)
    {
      this.goToPage(this.currentPage + 1);
    }
  }

  goToPage(index, force)
  {
    if(1 <= index && index <= this.pageCount && (index !== this.currentPage || force === true))
    {
      this.currentPage = index;

      this.rerender();

      if(utils.isFunction(this.onPageSwitch))
      {
        this.onPageSwitch(this.currentPage);
      }
    }
  }

  get pageCount()
  {
    return Math.ceil(this.items / this.itemsPerPage);
  }

  show()
  {
    if(utils.isNotNull(this.paginatorEl) && this.paginatorEl.length)
    {
      this.paginatorEl.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.paginatorEl) && this.paginatorEl.length)
    {
      this.paginatorEl.hide();
    }
  }
}



// WEBPACK FOOTER //
// ./app/js/components/paginator.js